import React from 'react';

import { Link, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  link: {
    color: '#388E3C',
    fontSize: '0.875rem',
  },
}));

const statusTextList = {
  completed: 'Completed',
  'in-progress': 'In Progress',
  'not-paid': 'Awaiting Payment',
};

const colorList = {
  completed: '#388E3C',
  'in-progress': '#E2A74F',
  'not-paid': '#B12A2A',
};

export default ({ rowIndex, status, onClick }) => {
  const classes = useStyles();

  const statusText = statusTextList[status];
  const color = colorList[status];

  const handleClick = (event) => {
    event.preventDefault();
    if (onClick) onClick(rowIndex);
    return false;
  };

  if (statusText === 'Completed') {
    return (
      <Link variant="button" onClick={handleClick} href="#" style={{ display: 'inline-block' }}>
        <Typography variant="body1" className={classes.link}>
          {statusText}
        </Typography>
      </Link>
    );
  }

  return <span style={{ color }}>{statusText}</span>;
};
